import { HTMLAttributes } from 'react'
import { Box, Container, Grid, Typography } from '@mui/material'
import parse from 'html-react-parser'

import Button from '@/components/base/button'
import Media from '@/components/base/media'

import { WPLink, WPMedia } from '@/types'

export type BannerProps = HTMLAttributes<HTMLDivElement> & {
  media: WPMedia
  content: {
    pretitle: string
    title: string
    subtitle: string
    text: string
  }
  button: {
    link: WPLink
    icon: string
  }
  alignment: 'left' | 'right'
  is_first?: boolean
}

const Banner = ({ media, content, button, is_first, alignment, ...props }: BannerProps) => {
  const isLeft = alignment === 'left'

  return (
    <Box {...props}>
      <Container>
        <Grid container>
          <Grid
            size={{ xs: 4, sm: 3, md: 4 }}
            order={{ md: isLeft ? 1 : 2 }}
            offset={{ md: isLeft ? 0 : 1 }}
          >
            <Box
              sx={{
                width: '100%',
                aspectRatio: '1/1',
                position: 'relative',
                zIndex: 1,
                overflow: 'hidden',
                borderRadius: (theme) => theme.shape.borderRadius6
              }}
            >
              <Media {...media} />
            </Box>
          </Grid>
          <Grid
            size={{ xs: 4, sm: 5, md: 6 }}
            order={{ md: isLeft ? 2 : 1 }}
            offset={{ md: 1 }}
            sx={{
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center'
            }}
          >
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'column',
                gap: 2
              }}
            >
              {content.pretitle ? (
                <Typography
                  variant="overline"
                  color="text.secondaryContrastText"
                  sx={{ width: '100%' }}
                >
                  {content.pretitle}
                </Typography>
              ) : null}
              {content.title ? (
                <Typography variant="h3" component={is_first ? 'h1' : 'h2'}>
                  {content.title}
                </Typography>
              ) : null}
              {content.subtitle ? (
                <Typography variant="textLarge" color="text.primary">
                  {content.subtitle}
                </Typography>
              ) : null}
              {content.text ? (
                <Typography variant="textRegular" color="text.secondary" component="span">
                  {parse(content.text)}
                </Typography>
              ) : null}
              {button?.link?.url ? (
                <Box sx={{ display: 'flex', width: '100%' }}>
                  <Button
                    href={button.link.url}
                    variant="contained"
                    color="primary"
                    icon={button.icon}
                  >
                    {button.link.title}
                  </Button>
                </Box>
              ) : null}
            </Box>
          </Grid>
        </Grid>
      </Container>
    </Box>
  )
}

export default Banner
